// modals/DeletePublicationModal.js
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiAlertTriangle } from "react-icons/fi";

const DeletePublicationModal = ({ show, onHide, onDelete, pubName }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FiAlertTriangle className="text-danger" /> Confirmer la désactivation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Êtes-vous sûr de vouloir <strong>désactiver</strong> la publication suivante ?
        <div className="alert alert-warning mt-3">
          <strong>{pubName}</strong>
        </div>
        <p className="text-muted small">
          Cette action ne supprime pas définitivement la publication. Vous pourrez la réactiver plus tard.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Annuler
        </Button>
        <Button variant="danger" onClick={onDelete}>
          Désactiver
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeletePublicationModal;